import React from 'react';
import { InspectionPlan } from '../types';

interface InspectionPlanTabProps {
  plans: InspectionPlan[];
  loading: boolean;
  onOpenCreate: () => void;
}

export const InspectionPlanTab: React.FC<InspectionPlanTabProps> = ({
  plans,
  loading,
  onOpenCreate,
}) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      <div className="card" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '16px' }}>
        <div>
          <h2 style={{ fontSize: '18px', fontWeight: 700, color: '#0f172a', margin: '0 0 4px 0' }}>
            Physical & Operational Inspection Plans
          </h2>
          <p style={{ fontSize: '13px', color: '#64748b', margin: 0 }}>
            Periodic execution schedules for aircraft, ramp, tooling/calibration, and facility inspections.
          </p>
        </div>
        <button
          onClick={onOpenCreate}
          className="btn-primary"
          style={{ width: 'auto', padding: '8px 16px', fontSize: '13px', display: 'inline-flex', alignItems: 'center', gap: '6px' }}
        >
          <span>+ New Inspection Plan</span>
        </button>
      </div>

      {!loading && plans.length === 0 ? (
        <div className="card" style={{ padding: '48px', textAlign: 'center', color: '#64748b' }}>
          No inspection plans registered.
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))', gap: '16px' }}>
          {plans.map((p) => (
            <div
              key={p.id}
              className="card"
              style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <span style={{ fontFamily: 'monospace', fontSize: '12px', fontWeight: 700, color: '#0284c7', background: '#e0f2fe', padding: '2px 8px', borderRadius: '4px' }}>
                  {p.planNumber}
                </span>
                <span
                  className={
                    p.status === 'ACTIVE'
                      ? 'badge-pill badge-success'
                      : p.status === 'DRAFT'
                      ? 'badge-pill badge-neutral'
                      : 'badge-pill badge-warning'
                  }
                >
                  {p.status}
                </span>
              </div>

              <div>
                <h3 style={{ fontWeight: 700, color: '#0f172a', fontSize: '16px', margin: 0 }}>{p.name}</h3>
                {p.description && (
                  <p style={{ fontSize: '12px', color: '#64748b', marginTop: '4px', overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>
                    {p.description}
                  </p>
                )}
              </div>

              <div style={{ fontSize: '12px', color: '#64748b', display: 'flex', flexDirection: 'column', gap: '6px', paddingTop: '10px', borderTop: '1px solid #f1f5f9' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span style={{ color: '#94a3b8' }}>Plan Type:</span>
                  <span style={{ fontWeight: 600, color: '#1e293b' }}>{p.planType}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span style={{ color: '#94a3b8' }}>Period:</span>
                  <span style={{ fontFamily: 'monospace', fontWeight: 500, color: '#1e293b' }}>
                    {p.periodStart} → {p.periodEnd}
                  </span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span style={{ color: '#94a3b8' }}>Frequency:</span>
                  <span style={{ fontWeight: 500, color: '#1e293b' }}>{p.frequency}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span style={{ color: '#94a3b8' }}>Owner:</span>
                  <span style={{ fontWeight: 500, color: '#1e293b' }}>{p.ownerId}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ color: '#94a3b8' }}>Risk-Based Methodology:</span>
                  <span
                    className={p.riskBased ? 'badge-pill badge-info' : 'badge-pill badge-neutral'}
                  >
                    {p.riskBased ? 'YES' : 'NO'}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
